import React from 'react'

import {SCORE_HEALTH} from 'constants/HealthCenterConstant'
import useGaugeStylesV1 from './styleV1'

interface Props {
  contentTitlePosition: {
    id: number
    text: string
  }[]
  index: number
}
function TitlePositionV1({index, contentTitlePosition}: Readonly<Props>) {
  const classes = useGaugeStylesV1()

  return (
    <>
      {index === 3 ? (
        <div className={classes.botBar}>
          <div>
            <div
              className={classes.marker3V1}
              style={{
                left: `${SCORE_HEALTH.low / 2}%`,
                transform: 'translateX(-50%)',
              }}
            >
              <div>{contentTitlePosition[0].text}</div>
            </div>
            <div
              className={classes.marker3V1}
              style={{left: '50%', transform: 'translateX(-50%)'}}
            >
              <div>{contentTitlePosition[1].text}</div>
            </div>
            <div
              className={classes.marker3V1}
              style={{
                left: `${SCORE_HEALTH.high + (100 - SCORE_HEALTH.high) / 2}%`,
                transform: 'translateX(-50%)',
              }}
            >
              <div>{contentTitlePosition[2].text}</div>
            </div>
          </div>
        </div>
      ) : (
        <div className={classes.processBar}>
          <div
            className={classes.marker1}
            style={{top: `${SCORE_HEALTH.low / 2}%`}}
          >
            <div>{contentTitlePosition[2].text}</div>
          </div>
          <div className={classes.marker1} style={{top: `50%`}}>
            <div>{contentTitlePosition[1].text}</div>
          </div>
          <div
            className={classes.marker1}
            style={{bottom: `${(100 - SCORE_HEALTH.high) / 2}%`}}
          >
            <div>{contentTitlePosition[0].text}</div>
          </div>
        </div>
      )}
    </>
  )
}
export default TitlePositionV1
